export default defineAppConfig({
	pageResolverName: 'pageResolver',
	pageResolverDir: 'pages-resolve',
	notFoundPagePath: '/not-found',
});
